@if (entity$ | async) {
  <mat-drawer-container class="h-full">
    <mat-drawer mode="over" [opened]="opened$ | async" (closed)="drawerClosed()" [position]="'end'" #matDrawer>
      <router-outlet name="task"></router-outlet>
    </mat-drawer>
    <mat-drawer-content>
      <div class="flex items-center justify-end mt-2 gap-2">
        <ts-button variant="secondary" icon="ts_file-save" (click)="openTaskExportDialog()"> Export </ts-button>
        <ts-button
          variant="primary"
          icon="add"
          [appAuthorize]="NewPermission.AGGREGATED_TASK_LISTS_CREATE"
          denyAction="disable"
          (click)="createTask()"
          >Add Task
        </ts-button>
      </div>
      <div class="flex flex-col w-full">
        <div class="note-list">
          <tasks-crm-panel [tasks]="tasks$ | async" (openTaskDetails)="openTaskDetails($event)"></tasks-crm-panel>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
}
